module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "chptitle"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("Chapter 4")])]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Red and Dana Myers showed up at one o’clock as Corrie was checking in five reservations and three drop-ins. Dana jumped right in and started helping out while Red quickly parked their restored Airstream and stepped in to escort campers to their sites. It was well after two before they were able to sit down with fresh cups of coffee and say “hello” to each other.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Glad Jackie called us,” Dana said, running a hand through her short, frosted blond hair that belied her almost-sixty years. “Today would have been a nightmare for you! I’m just sorry we didn’t get here sooner. I know I said we’d be here at ten o’clock, but we got a late start and I thought you’d have some help this morning.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Red leaned back in his chair and sighed, wiping a handkerchief over his brow. Hustling from one campsite to another, helping the guests with their hook-ups, made the spring afternoon warmth overwhelming for someone of Red’s age and weight. His face and arms were the color of his thinning hair and copious freckles. “Dee Dee’s off today?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Corrie grimaced. She’d been so busy she’d forgotten that her part-time help, Dee Dee Simpson, was supposed to have come in at eleven. “She wasn’t supposed to be.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Is she at the sheriff’s department today, or the salon?” Dana asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Corrie shook her head. Dee Dee held down three jobs, all part-time, and she sold Glamour Girl cosmetics on the side when she wasn’t running off to auditions for modeling, singing, or acting jobs of which a cousin in L.A. kept her informed. It wasn’t unusual for Dee Dee to take off without letting her employers know when she was going, or changing her work schedule without consulting them. It was a mystery to Corrie why she hadn’t fired her already. “I can’t keep track of her work schedule here, you think I’d know where else she’s supposed to be?” Corrie said. She heard the roar of an expensive sports car end with a slight squeal and the sound of tires skidding on gravel. “But I’d be willing to bet that’s her right now!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The front door flew open and Dee Dee charged into the room, a whirlwind of impossibly yellow hair in a skin-tight, black-and-fuschia zebra-striped jumpsuit, talking a mile a minute. “Unbelievable!” she was saying, shaking her head so hard her multiple hoop earrings swung wildly. “I just can’t believe it!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What, that you forgot you were supposed to be here at eleven?” Corrie asked.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("“Oh!” Dee Dee stopped, pursed her fuchsia pink lips and grimaced. “I ")]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("was, wasn’t I? Oh, well….” She shrugged.")])]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Corrie managed to rein in her temper. “What happened this time?” she asked. Somewhere along the way she had become something of a big sister to the capricious young woman and she wondered if Dee Dee had any intention of offering a semblance of apology.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Dee Dee dropped into a chair across from Corrie. “You haven’t heard yet?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Corrie sighed and rolled her eyes. “Evidently not,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Dee Dee glanced at both Red and Dana. Red shook his head. Dana said, “We just got into town about an hour ago.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s about Betty Landry,” Dee Dee said in what, Corrie assumed, was her idea of a conspiratorial whisper, as she leaned across the table. This time Corrie sat bolt upright and gave her her full attention.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Betty Landry? What happened to her?” The Landrys—Marvin and Betty—were seventy-something retirees who’d spent the last twenty summers at the Black Horse Campground. They usually arrived the weekend after Mother’s Day. Recently, Betty had been plagued with bad health and the Christmas card Corrie received from them in December hinted that she was declining, but Corrie hoped that Dee Dee’s announcement wasn’t what she was dreading it might be.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Dee Dee’s eyes—emerald-green today—widened and her lips trembled. She was in a full-blown “bearer of tragic news” role and only Corrie’s fear that maybe Dee Dee wasn’t acting kept her from cutting the performance short. Tears gleamed in the corners of Dee Dee’s eyes. “She’s in a wheelchair,” Dee Dee choked and sat back, her hands to her lips and her eyes blinking rapidly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Corrie and Dana stared at her. Dee Dee seemed unaware that her news was rather anti-climactic. Red spoke up and said what the women were thinking and were too polite to say. “So?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Dee Dee’s eyes turned from glassy to frosty in an instant and she focused her narrowed gaze on Red. “How can you say that?” she gasped. “She’s in a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("wheelchair")]), _vm._v("!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Dee Dee,” Corrie said. “I realize it’s a bit of a shock, but didn’t you get a card from the Landrys at Christmas telling you she wasn’t doing too well?” Betty sent Christmas cards to practically everyone they’d ever met. She told Corrie it was her way of staving off boredom during their non-traveling times.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, yeah, but a wheelchair! How awful!” Dee Dee moaned, her natural drawl replacing her previous funereal tones. Evidently ending up in a wheelchair was, in Dee Dee’s estimation, the proverbial fate worse than death and she couldn’t understand why everyone wasn’t as devastated as she was. Dana spoke up.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("“How did you happen to find out about this?” she asked.")])]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Dee Dee’s tragic look evaporated. She blinked and gave Dana, then Corrie, a vacant look. “Well … they’re here, aren’t they?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Here?” Corrie echoed. “Here, where?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why, here at the Black Horse. I mean, I assume they’re staying here.” Dee Dee frowned, wrinkling her nose and shaking her head. “But that’s right, you didn’t know about Betty being in a wheelchair, so maybe they just haven’t checked in yet….”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Okay, back up, Dee Dee, start over,” Corrie interrupted. “Betty Landry is in a wheelchair. You know this … how?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Dee Dee stared at her. “I saw her and Marvin going into the bank as I was leaving the salon. They’ve got one of those lifts installed in their RV and I watched Marvin get Betty down and wheel her into the bank.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re sure it was the Landrys’ RV?” Corrie asked. Dee Dee nodded.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("“Of course I’m sure. Not too many Winnebagos that have ‘The End of the Road’ painted on the back, with ‘Marvin and Betty’ written right under it!”")]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a867a1d2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/07_Chapter04.vue
// module id = 87
// module chunks = 0